import { render } from "./event.vue?vue&type=template&id=66680b6c&scoped=true"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"

import "./event.vue?vue&type=style&index=0&id=66680b6c&lang=scss&scoped=true"
import "./event.vue?vue&type=style&index=1&id=66680b6c&lang=scss"
script.render = render
script.__scopeId = "data-v-66680b6c"

export default script